// extracted by mini-css-extract-plugin
export default {"token":"bhvP3W","hover":"chvP3W","disabled":"dhvP3W"};